import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import { ENDPOINTS } from 'features/daily-plan/constants';
import { useShowAlert } from 'hooks';
import API from 'services/API';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import DecisionDialog from 'UI/components/organisms/DecisionDialog';
import { MAX_TASKS_LIMIT } from 'UI/pages/DailyPlan/DailyPlan.constants';

import { ARCHIVED_ACTIONS } from '../ArchiveActions.constants';

export const ArchiveActionsDialog = ({
  mode = ARCHIVED_ACTIONS.Archive,
  onComplete = () => {},
  onClose = () => {},
  selectedItems = []
}) => {
  const { showAlert } = useShowAlert();
  const [uiState, setUiState] = useState({
    isLoading: false,
    error: null
  });

  const totalSelected = selectedItems?.length;
  const isLimitExceeded = totalSelected > MAX_TASKS_LIMIT;
  const dialogTitle = strings.dailyPlan.archiveActions.decisionDialog[mode].title;
  const dialogDescription = strings.dailyPlan.archiveActions.decisionDialog[mode].description;

  const handleOnConfirm = async () => {
    try {
      setUiState(prev => ({ ...prev, isLoading: true, error: null }));

      const endpoint =
        mode === ARCHIVED_ACTIONS.Archive ? ENDPOINTS.tasksArchive : ENDPOINTS.tasksRestore;

      const response = await API.post(endpoint, { ids: selectedItems });

      setUiState(prev => ({
        ...prev,
        isLoading: false
      }));

      if (response.status === HTTPStatusCodes.Ok) {
        setUiState(prev => ({
          ...prev,
          error: null
        }));
        showAlert({
          title: strings.dailyPlan.archiveActions.decisionDialog[mode].success,
          autoHideDuration: 5000
        });

        await onComplete();
      }
    } catch (error) {
      setUiState(prev => ({
        ...prev,
        isLoading: false,
        error: strings.dailyPlan.rescheduleActions.fail
      }));
      showAlert({
        autoHideDuration: 5000,
        title: strings.dailyPlan.archiveActions.decisionDialog[mode].title,
        error
      });
    }
  };

  return (
    <DecisionDialog
      cancelButtonText={strings.shared.ui.cancel}
      confirmButtonText={mode}
      fetching={uiState.isLoading}
      isOpened
      onClose={onClose}
      onConfirm={handleOnConfirm}
      severity="info"
      showCloseButton={false}
      showSeverityIcon={false}
      title={dialogTitle}
      withButtons="YesNo"
    >
      <When condition={isLimitExceeded}>
        <Alert severity="warning" className="margin-y1">
          {strings.formatString(strings.dailyPlan.archiveActions.decisionDialog.limitExceeded, {
            totalSelected,
            maxItemsLimit: MAX_TASKS_LIMIT,
            mode
          })}
        </Alert>
      </When>
      <Typography variant="body1">{dialogDescription}</Typography>
      <When condition={uiState.error}>
        <Alert severity="error" className="margin-y1">
          {uiState.error}
        </Alert>
      </When>
    </DecisionDialog>
  );
};
